import { EGGSHELL_CREW, GREEN_CREW, Product, WHITE_HAT } from '../products';

const socksRecos: Product[] = [
    EGGSHELL_CREW, 
    GREEN_CREW,
    WHITE_HAT,
];

export default socksRecos;